import axios from "axios";
import { normalizeServices } from "../../utils/service";

export default {
  data() {
    return {
      organizations: [],
      researchAreas: [],
      services: [],
      categories: [],
      workplaces: [],
      vacations: [],
      vinculationTypes: [],
      citicenships: [],
    };
  },

  computed: {
    sortedServices() {
      if (!Array.isArray(this.services)) {
        return [];
      }
      return this.services
        .filter(service => service && service.hidden !== true)
        .slice().sort((a, b) => {
        const orderDiff = (a.order || 0) - (b.order || 0);
        if (orderDiff !== 0) {
          return orderDiff;
        }
        return String(a.name || "").localeCompare(String(b.name || ""));
      });
    }
  },

  methods: {
    getOrganizations() {
      let path = this.$store.state.endpoint + "/organization";
      axios
        .get(path)
        .then(response => {
          this.organizations = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getResearchAreas() {
      let path = this.$store.state.endpoint + "/researchArea";
      axios
        .get(path)
        .then(response => {
          this.researchAreas = response.data.filter(area => !(area.closed || area.deprecated));
        })
        .catch(error => {
          console.log(error);
        });
    },
    getAllResearchAreas() {
      let path = this.$store.state.endpoint + "/researchArea";
      axios
          .get(path)
          .then(response => {
            this.researchAreas = response.data;
          })
          .catch(error => {
            console.log(error);
          });
    },
    getServices() {
      let path = this.$store.state.endpoint + "/service/no-basic";
      axios
        .get(path)
        .then(response => {
          this.services = normalizeServices(response.data).sort((a, b) =>
            a.name > b.name ? 1 : b.name > a.name ? -1 : 0
          );
        })
        .catch(error => {
          console.log(error);
        });
    },
    getCategories() {
      let path = this.$store.state.endpoint + "/category";
      axios
        .get(path)
        .then(response => {
          this.categories = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getWorkplaces() {
      let path = this.$store.state.endpoint + "/workplace";
      axios
        .get(path)
        .then(response => {
          this.workplaces = response.data.sort((a, b) => {
            const nameComparison = a.name.localeCompare(b.name);
            if (nameComparison !== 0) return nameComparison;
            return a.place_code.localeCompare(b.place_code);
          });
        })
        .catch(error => {
          console.log(error);
        });
    },

    getVacations() {
      let path = this.$store.state.endpoint + "/utils/vacations";
      axios
        .get(path)
        .then(response => {
          this.vacations = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },

    getVinculationTypes() {
      let path = this.$store.state.endpoint + "/utils/vinculationTypes";
      axios
        .get(path)
        .then(response => {
          response.data.forEach(type => {
            this.vinculationTypes.push({
              text: this.$t("vinculation.types." + type),
              value: type
            });
            const order = {
              training_investigator: 0,
              competitive_program_investigator: 1,
              posdoc_investigator: 2
            };
            this.vinculationTypes.sort((a, b) => {
              const aOrder = order[a.value];
              const bOrder = order[b.value];
              if (aOrder !== undefined && bOrder !== undefined) {
                return aOrder - bOrder;
              }
              return a.text.localeCompare(b.text);
            });
          });
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
